import { defineMessages } from 'react-intl';

const messages = defineMessages({
  existenceError: {
    id: 'accountSignin.forgotPasswordColumn.emailErrorExistence',
    defaultMessage: 'Please enter your email address.',
    description: 'Error message displayed when email address is missing',
  },
  invalidError: {
    id: 'accountSignin.forgotPasswordColumn.emailErrorInvalid',
    defaultMessage: 'Please enter a valid email address.',
    description: 'Error message displayed when email address is invalid',
  },
  resetPassword: {
    id: 'accountSignin.forgotPasswordColumn.submit',
    defaultMessage: 'Reset password',
    description: 'Button text for forgot password form.',
  },
});

export default messages;
